import { DateRangeDropdownV2, FormFieldV2 as FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

const BasicInfo = () => {
  return (
    <div className='flex flex-col space-y-2 p-4'>
      <div className='flex w-96 items-center'>
        <Label className='w-40 min-w-40'>Ngày từ/đến:</Label>
        <DateRangeDropdownV2 fromDateName='ngay_ct1' toDateName='ngay_ct2' />
      </div>
      <div className='flex w-96 items-center'>
        <Label className='w-40'>Số c/từ (từ/đến):</Label>
        <div className='flex items-center gap-2'>
          <FormField name='so_ct1' type='text' />

          <FormField name='so_ct2' type='text' />
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
